document.addEventListener("reintegrationFormSubmitted", afterSubmitSexes);

function afterSubmitSexes({ detail: e }) {
  if (e.data.success) {
    // Трекінг події Lead через Meta Pixel
    if (typeof fbq === "function") {
      fbq("track", "Lead");
      console.log("Meta Pixel: Lead event sent");
    }

    e.form.reset();
    e.form.classList.add("sended-sexes");
    setTimeout(() => {
      e.form.classList.remove("sended-sexes");
      e.form.querySelector("button").disabled = false;
    }, 15000);
  } else {
    alert(
      e.data?.data?.message || "Помилка при відправці форми. Спробуйте ще раз."
    );
  }
}
